export enum FatalErrorKey {
  NO_CLIENT_CONFIGURATION = 'no-client-configuration',
  CLIENT_CONFIGURATION_404 = 'client-configuration-404',
  NO_SERVER_CONNECTION = 'no-server-connection',
  NO_VALID_PRODUCTS = 'no-valid-products',
}
